import React from "react";
import { StationFormData, StationFormErrors } from "../NewStationFormPresenter";
import { UserRole, userRoles } from "../../../../../user/types/user.types";
import styles from "./NewStationFormView.module.scss";
import MessageCard from "../../../../../../common/components/molecule/MessageCard/MessageCard";
import TextInput from "../../../../../../common/components/atom/TextInput/TextInput";
import Button from "../../../../../../common/components/atom/Button/Button";

export interface NewStationFormProps {
  formData?: StationFormData;
  setFormData: (key: keyof StationFormData, value: string) => void;
  errorStatus?: StationFormErrors;
  handleSubmit?: () => void;
  messageError?: string | null;
  isLoading?: boolean;
  submitLabel?: string;
  description?: string;
  title?: string;
  maxWidth?: string;
  currentUserRoleCreator?: UserRole;
  isUpdate?: boolean;
  organizationPickerRender?: () => JSX.Element;
}

/**
 * NewStationFormView
 * @param param0
 * @returns
 */
export default function NewStationFormView({
  handleSubmit,
  messageError,
  errorStatus,
  isLoading,
  submitLabel = "Créer",
  description = "Saisissez les informations de la nouevlle station",
  maxWidth = "700px",
  title,
  formData,
  setFormData,
  currentUserRoleCreator,
  isUpdate,
  organizationPickerRender,
}: NewStationFormProps) {
  return (
    <div style={{ maxWidth: maxWidth }}>
      <div className={[styles["container"]].join(" ")}>
        {title && (
          <h1 className={[styles["container__title"]].join(" ")}>{title}</h1>
        )}
        <p className={[styles["container__description"]].join(" ")}>
          {description}
        </p>
        <div className={[styles["container__error-message"]].join(" ")}>
          <MessageCard variant="danger" message={messageError} width100 />
        </div>
        <form
          className={[styles["form"]].join(" ")}
          onSubmit={(e) => {
            e.preventDefault();
            handleSubmit && handleSubmit();
          }}
        >
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Nom de la station*"
              value={formData?.name}
              error={errorStatus?.isErrorName}
              onChange={(e) => {
                setFormData("name", e.target.value);
              }}
            />
          </div>

          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Device ID*"
              value={formData?.deviceId}
              error={errorStatus?.isErrorHardwareId}
              onChange={(e) => {
                setFormData("deviceId", e.target.value);
              }}

              type="number"
            />
          </div>
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Slug*"
              value={formData?.slug}
              error={errorStatus?.isErrorSlug}
              onChange={(e) => {
                setFormData("slug", e.target.value);
              }}
            />
          </div>
          {((organizationPickerRender !== undefined)&& ((  currentUserRoleCreator  !== undefined) && (  currentUserRoleCreator >= userRoles.SUPER_ADMIN)))? (
            <div className={[styles["form__item"]].join(" ")}>
              {organizationPickerRender()}
            </div>
          ): <></>}



          <h2 className={[styles["form__intersection-name"]].join(" ")}>
            Adresse
          </h2>

          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="N°, rue, avenue, etc."
              value={formData?.street}
              error={errorStatus?.isErrorStreet}
              onChange={(e) => {
                setFormData("street", e.target.value);
              }}
            />
          </div>
          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Code postal"
              value={formData?.zipCode}
              error={errorStatus?.isErrorZipCode}
              onChange={(e) => {
                setFormData("zipCode", e.target.value);
              }}
            />
          </div>

          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Ville"
              value={formData?.city}
              error={errorStatus?.isErrorCity}
              onChange={(e) => {
                setFormData("city", e.target.value);
              }}
            />
          </div>

          <div className={[styles["form__item"]].join(" ")}>
            <TextInput
              label="Pays"
              value={formData?.country}
              error={errorStatus?.isErrorCountry}
              onChange={(e) => {
                setFormData("country", e.target.value);
              }}
            />
          </div>

          <h2 className={[styles["form__intersection-name"]].join(" ")}>
            Localisation
          </h2>
          <div className={[styles["form__row"]].join(" ")}>
            <div
              className={[
                styles["form__item"],
                styles["form__item--row"],
                styles["form__item--row--left"],
              ].join(" ")}
            >
              <TextInput
                label="Latitude"
                value={formData?.latitude}
                error={errorStatus?.isErrorLatitude}
                onChange={(e) => {
                  setFormData("latitude", e.target.value);
                }}
                type="number"
              />
            </div>
            <div
              className={[
                styles["form__item"],
                styles["form__item--row"],
                styles["form__item--row--right"],
              ].join(" ")}
            >
              <TextInput
                label="Longitude"
                value={formData?.longitude}
                error={errorStatus?.isErrorLongitude}
                onChange={(e) => {
                  setFormData("longitude", e.target.value);
                }}
                type="number"
              />
            </div>
          </div>
          <div className={[styles["form__button-container"]].join(" ")}>
            <div className={[styles["form__button-container__item"]].join(" ")}>
              <Button
                isLoading={isLoading}
                onClick={handleSubmit}
                type={"submit"}
              >
                {submitLabel}
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
